<script setup lang="ts">

import {useFormatStore} from "@/stores/formatStore";
import {useI18n} from "vue-i18n";

const formatStore = useFormatStore()
const {t} = useI18n(); // `t` for translating strings


const emit = defineEmits([
  'on-click'
])

const props = defineProps({
  'title': String,
  'selector': String,
  'color': String,
  'scrolled': Boolean,
  'bundle': Object,
  'selected': Boolean,
  'loading': Boolean,
})


function formatYearRanges(minYear: string, maxYear: string) {
  if (!minYear) {
    return '-';
  }
  if (minYear == maxYear) {
    return minYear;
  } else {
    return minYear + '-' + maxYear;
  }
}

</script>
<template>
  <div
      class="w-full min-w-fit p-5 flex flex-col gap-4 rounded-8xl transition-all tab middle-tab"
      :class="{ 'selected-tab': props.selected, 'scrolled': props.scrolled, ['bg-' + props.selector]: true }"
      @click="emit('on-click')"
      :style="{ '--tab-after-color': props.color }"
  >
    <div class="flex flex-row justify-between align-center">
      <div class="flex gap-1 align-center mr-3">
        <img src="@/assets/icons/types/standard.svg" />
        <span class="tab-category__title font-semibold responsive-title-5">{{ props.title }}</span>
      </div>
      <div class="responsive-body-small flex gap-1" v-if="props.bundle.count">
        <span class="font-semibold">{{
            props.bundle.count
          }}</span>
        <span>{{ t('tabs.yachts') }}</span>
      </div>
    </div>

    <!-- Hide this row when scrolled -->
    <div
        class="flex justify-between align-center tab-second-row transition-opacity"
        :class="{ 'opacity-0 pointer-events-none': props.scrolled }"
    >
      <div class="responsive-body-small built-year">
        <p class="font-semibold">{{ t('tabs.builtYear') }}</p>
        <p v-if="props.bundle && props.bundle.models.length > 0">
          {{ formatYearRanges(props.bundle.minYear, props.bundle.maxYear) }}
        </p>
      </div>
      <div class="flex flex-col">
        <p class="responsive-body-small tabs-from">{{ t('tabs.from') }}</p>
        <p class="font-semibold responsive-title-6">
          <div v-if="props.loading">
            <el-skeleton style="--el-skeleton-color: #000" class="w-full" :rows="0" />
          </div>
          <div v-if="!props.loading">
            <div v-if="props.bundle.count <= 0">-</div>
            <div class="tab-category__min-price" v-if="props.bundle.count > 0">
              {{ formatStore.formatCurrency(props.bundle.minPrice) }}
            </div>
          </div>
        </p>
      </div>
    </div>
  </div>
</template>


<style scoped>
:deep(.tabs .el-skeleton) {
  width: 5vw;
}

:deep(.tabs .el-skeleton__item.el-skeleton__p ) {
  width: 4.5vw;
}

:deep(.boat-result-container .el-skeleton) {
  width: 8vw;
}

:deep(.boat-result-container .el-skeleton__item.el-skeleton__p ) {
  width: 6.5vw;
}

:deep(.boat-stats-container .el-skeleton) {
  width: 6vw;
}

:deep(.boat-stats-container .el-skeleton__item.el-skeleton__p ) {
  width: 4.5vw;
}

:deep(.el-loading-mask) {
  @apply z-20;
}


.boat-result-mob__buttons button:not(button.border-primary-blue):hover {
  border-color: #000 !important;
}


.tab {
  padding: 20px;
  cursor: pointer;
  position: relative;
}

.tab.selected-tab {
  padding-top: 25px;
  padding-bottom: 25px;
}


.tabs:has(.tab.scrolled) {
  padding-top: 0.5rem !important;
}

.tab.scrolled {
  gap: .5rem;
}

.tab.scrolled img {
  width: 1.875rem !important;
}

.tab.scrolled .tab-second-row {
  display: none;
}

.tab.scrolled .tab-category__title {
  font-size: 1.25rem;
}

.tab.scrolled .tabs-from {
  opacity: 0;
  display: none;
}

.tab.scrolled .tab-category__min-price {
  font-size: 1rem;
}



@media (max-width: 1024px) {
  :deep(.tabs .el-skeleton__item.el-skeleton__p ) {
    width: 5.8vw;
  }
}

@media (min-width: 886px) {

  .tabs .tab:not(.selected-tab) {
    transform: scale(.95);
  }

  .tab.selected-tab::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -25px;
    width: 100%;
    height: 5px;
    border-radius: 5px;
    background-color: var(--tab-after-color);
  }

}

@media (max-width: 885px) {

  .tabs .tab:not(.selected-tab) {
    transform: scale(.93);
  }
}


@media (max-width: 400px) {

  .tabs .tab:not(.selected-tab) {
    transform: scale(.95);
  }

  .tab.selected-tab::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -25px;
    width: 100%;
    height: 5px;
    border-radius: 5px;
    background-color: var(--tab-after-color);
  }
}
</style>